if (!customElements.get('byte-promo-cards')) {
    class BytePromoCards extends HTMLElement {
      connectedCallback() {
        this.track     = this.querySelector('.byte-promo-cards__grid');
        this.dotsWrap  = this.querySelector('.byte-promo-cards__dots');
        if (!this.track || !this.dotsWrap) return;
  
        this.enableSlider = this.dataset.slider === 'true';
        this.colsDesktop  = parseInt(this.dataset.colsDesktop, 10);
        this.colsMobile   = parseInt(this.dataset.colsMobile,  10);
        this.blockCount   = parseInt(this.dataset.blockCount,  10);
  
        this.dots  = Array.from(this.dotsWrap.querySelectorAll('.byte-promo-cards__dot'));
        this.items = Array.from(this.track.querySelectorAll('.byte-promo-cards__item'));
  
        this._onScroll = this._handleScroll.bind(this);
        this._onResize = this._debounce(this._init.bind(this), 150);
  
        this.track.addEventListener('scroll', this._onScroll, { passive: true });
        window.addEventListener('resize', this._onResize);
  
        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => {
            this._scrollToPage(parseInt(dot.dataset.index, 10));
          });
        });
  
        this._init();
      }
  
      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this._onScroll);
        window.removeEventListener('resize', this._onResize);
      }
  
      _isMobile() {
        return window.innerWidth < 750;
      }
  
      _currentCols() {
        return this._isMobile() ? this.colsMobile : this.colsDesktop;
      }
  
      _needsSlider() {
        if (!this.enableSlider) return false;
        if (this._isMobile()) return true;
        return this.blockCount > this.colsDesktop;
      }
  
      _pageCount() {
        return Math.ceil(this.blockCount / this._currentCols());
      }
  
      _activateDot(index) {
        this.dots.forEach((dot, i) => {
          const active = i === index;
          dot.classList.toggle('byte-promo-cards__dot--active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      }
  
      _scrollToPage(pageIndex) {
        const cols       = this._currentCols();
        const targetItem = this.items[pageIndex * cols];
        if (!targetItem) return;
        this.track.scrollTo({ left: targetItem.offsetLeft, behavior: 'smooth' });
        this._activateDot(pageIndex);
      }
  
      _handleScroll() {
        clearTimeout(this._scrollTimer);
        this._scrollTimer = setTimeout(() => {
          const cols = this._currentCols();
          if (!this.items[0]) return;
          const gap       = parseFloat(getComputedStyle(this.track).getPropertyValue('--byte-promo-cards-gap')) || 0;
          const pageWidth = this.items[0].offsetWidth * cols + gap * (cols - 1);
          if (pageWidth === 0) return;
          const page = Math.round(this.track.scrollLeft / pageWidth);
          this._activateDot(Math.max(0, Math.min(page, this._pageCount() - 1)));
        }, 50);
      }
  
      _init() {
        if (this._needsSlider()) {
          this._activate();
        } else {
          this._deactivate();
        }
      }
  
      _activate() {
        this.track.classList.add('byte-promo-cards__grid--slider');
  
        const pageCount = this._pageCount();
        this.dots.forEach((dot, i) => { dot.hidden = i >= pageCount; });
        this.dotsWrap.hidden = false;
  
        this._activateDot(0);
        this.track.scrollLeft = 0;
      }
  
      _deactivate() {
        this.track.classList.remove('byte-promo-cards__grid--slider');
        this.dotsWrap.hidden = true;
        this.track.scrollLeft = 0;
      }
  
      _debounce(fn, delay) {
        let timer;
        return (...args) => {
          clearTimeout(timer);
          timer = setTimeout(() => fn(...args), delay);
        };
      }
    }
  
    customElements.define('byte-promo-cards', BytePromoCards);
  }